import { makeRequest } from '../../../api';
import {
  CONNECT_SOCIAL_INTERNET,
  DISABLE_SERVICE_CHECK,
  DISABLE_SERVICE,
  CANCEL_FUTURE_TASK,
  CHANGE_FIREWALL,
  GET_POPUP_SOCIAL_INTERNET,
  GET_POPUP_ADDITIONAL_SERVICE,
  CONNECT_ADDITIONAL_SERVICE,
  CONNECT_ADDITIONAL_SERVICE_PROMISED_PAYMENT,
  FTTB_STATUS,
  GET_WIFI_ROUTER_RETURN_INFO,
} from './endpoints';

export const getFTTBStatusRequest = () => makeRequest({
  url: FTTB_STATUS,
});

export const connectSocialInternetRequest = (data) => makeRequest({
  url: CONNECT_SOCIAL_INTERNET,
  method: 'POST',
  data,
});

export const disableServiceCheckRequest = (splId, serviceId) => makeRequest({
  url: DISABLE_SERVICE_CHECK,
  params: { splId, serviceId },
});

export const disableServiceRequest = (data) => makeRequest({
  url: DISABLE_SERVICE,
  method: 'POST',
  data,
});

export const cancelFutureTaskRequest = (data) => makeRequest({
  url: CANCEL_FUTURE_TASK,
  method: 'POST',
  data,
});

export const changeFirewallRequest = (params) => makeRequest({
  url: CHANGE_FIREWALL,
  params,
});

export const getPopupSocialInternetRequest = () => makeRequest({
  url: GET_POPUP_SOCIAL_INTERNET,
});

export const getPopupAdditionalServiceRequest = (serviceId) => makeRequest({
  url: GET_POPUP_ADDITIONAL_SERVICE,
  params: { serviceId },
});

export const connectAdditionalServiceRequest = (data) => makeRequest({
  url: CONNECT_ADDITIONAL_SERVICE,
  method: 'POST',
  data,
});

export const connectAdditionalServicePromisedPaymentRequest = (data) => makeRequest({
  url: CONNECT_ADDITIONAL_SERVICE_PROMISED_PAYMENT,
  method: 'POST',
  data,
});

export const getWifiRouterReturnInfoRequest = (serial) => makeRequest({
  url: GET_WIFI_ROUTER_RETURN_INFO,
  params: { serial },
});
